import L from 'leaflet'
import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
// Создадим компонент-контрол, который будет добавлять на карту кнопку и инпут

export default function DrawCircleControl ({
  onDrawCircle,
  circleRadius,
  setCircleRadius
}: {
  onDrawCircle: () => void
  circleRadius: number
  setCircleRadius: (val: number) => void
}) {
  const map = useMap()
  // или const map = useMap(); // (импортировать из 'react-leaflet') если v3+

  useEffect(() => {
    if (!map) return

    // Создаем кастомный контрол
    const control = new L.Control({ position: 'topleft' })

    control.onAdd = function (map) {
      // Создаем контейнер
      const container = L.DomUtil.create(
        'div',
        'leaflet-bar leaflet-control leaflet-control-custom'
      )

      container.style.backgroundColor = 'white'
      container.style.padding = '4px 6px'
      container.style.cursor = 'auto'
      container.style.minWidth = '120px'
      container.style.font = '14px/1.2 sans-serif'

      // Предотвращаем пропадание фокуса или перехват кликов картой
      L.DomEvent.disableClickPropagation(container)
      L.DomEvent.disableScrollPropagation(container)

      // Вставляем простую верстку (кнопку и инпут)
      container.innerHTML = `
        <div style="margin-bottom:4px;">
          <label style="display:block;margin-bottom:4px;">Радиус (м):</label>
          <input
            type="number"
            id="circleRadiusInput"
            value="${circleRadius}"
            style="width: 100%; margin-bottom: 6px; border: 1px solid #ccc; padding: 4px;"
          />
        </div>
        <button
          id="drawCircleButton"
          style="width: 100%; background: #42b983; color: white; border: none; padding: 6px; cursor: pointer;"
        >
          Нарисовать круг
        </button>
      `

      // Навешиваем обработчик на кнопку
      const button = container.querySelector('#drawCircleButton')
      button?.addEventListener('click', () => {
        // Считываем актуальный радиус из инпута
        const input = container.querySelector('#circleRadiusInput') as HTMLInputElement
        const newRadius = Number(input.value || 0)
        setCircleRadius(newRadius)
        onDrawCircle()
      })

      return container
    }

    // Добавляем контрол на карту
    control.addTo(map)

    // Удаляем при размонтировании
    return () => {
      map.removeControl(control)
    }
  }, [map, onDrawCircle, circleRadius, setCircleRadius])

  return null // сам по себе компонент ничего не рендерит
}
